module.exports = "/assets/904a58272f9aef7e08cd32b91d37fa2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/9V.png
// module id = 1174
// module chunks = 0